import React from "react";
import HeroSection from "./heroSection/HeroSection";
import AboutSection from "./aboutSection/AboutSection";
import FeaturesSection from "./featuresSection/FeaturesSection";
import ResortGallery from "./resortGallery/ResortGallery";
import MenuSection from "../about_us/menuSection/MenuSection";

function Home() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <MenuSection />
      <FeaturesSection />

      <ResortGallery />
    </>
  );
}

export default Home;
